module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newIntegration"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v(_vm._s(_vm.actionText) + "奖品\n\t\t"), _c('span', [_c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("取消")])], 1)]), _vm._v(" "), _c('div', [_c('el-form', {
    ref: "inteForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.inteForm,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "奖品名称：",
      "prop": "prizeName"
    }
  }, [_c('el-input', {
    staticClass: "inputTitle",
    attrs: {
      "placeholder": "奖品名称"
    },
    model: {
      value: (_vm.inteForm.prizeName),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "prizeName", $$v)
      },
      expression: "inteForm.prizeName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "奖品图片：",
      "prop": "imgUrl",
      "required": ""
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.logoActionUrl,
      "with-credentials": true,
      "accept": "image/*",
      "name": "uploadFile",
      "type": "drag",
      "thumbnail-mode": true,
      "on-error": _vm.handleError,
      "on-success": _vm.handleSuccess
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("将文件拖到此处，或\n\t\t\t\t\t\t"), _c('em', [_vm._v("点击上传")])])]), _vm._v(" "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("（尺寸说明：360×300像素，jpg、jpeg、png）")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "中奖概率：",
      "prop": "probability",
      "required": ""
    }
  }, [_c('el-input', {
    staticClass: "probability",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "中奖概率总和为100%"
    },
    model: {
      value: (_vm.inteForm.probability),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "probability", _vm._n($$v))
      },
      expression: "inteForm.probability"
    }
  }, [_c('template', {
    staticStyle: {
      "line-height": "34px"
    },
    slot: "append"
  }, [_vm._v("%")])], 2), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("（可配置的最低中奖概率为0.01%）")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "自动兑奖:",
      "required": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.inteForm.isAuto),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "isAuto", $$v)
      },
      expression: "inteForm.isAuto"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "inline",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.inteForm.isAuto),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "isAuto", $$v)
      },
      expression: "inteForm.isAuto"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否无限:",
      "required": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.inteForm.isInfinite),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "isInfinite", $$v)
      },
      expression: "inteForm.isInfinite"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "inline",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.inteForm.isInfinite),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "isInfinite", $$v)
      },
      expression: "inteForm.isInfinite"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "奖品库存:",
      "prop": "fileUrl"
    }
  }, [_c('el-upload', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "action": _vm.importAction,
      "with-credentials": true,
      "on-success": _vm.success,
      "on-error": _vm.handleError,
      "name": "uploadFile"
    }
  }, [_c('el-button', [_vm._v("选择文件")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "可中奖次数:",
      "required": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.inteForm.isLimit),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "isLimit", $$v)
      },
      expression: "inteForm.isLimit"
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('el-radio', {
    staticClass: "inline",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.inteForm.isLimit),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "isLimit", $$v)
      },
      expression: "inteForm.isLimit"
    }
  }, [_vm._v("限定")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.inteForm.isLimit == "1") ? _c('el-input', {
    staticClass: "probability",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入自定义数量"
    },
    model: {
      value: (_vm.inteForm.drawHitCount),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "drawHitCount", $$v)
      },
      expression: "inteForm.drawHitCount"
    }
  }, [_c('template', {
    staticStyle: {
      "line-height": "34px"
    },
    slot: "append"
  }, [_vm._v("次")])], 2) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "兑奖URL:",
      "required": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "false"
    },
    model: {
      value: (_vm.inteForm.definePrizeUrl),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "definePrizeUrl", $$v)
      },
      expression: "inteForm.definePrizeUrl"
    }
  }, [_vm._v("不跳转")]), _vm._v(" "), _c('el-radio', {
    staticClass: "inline",
    attrs: {
      "label": "true"
    },
    model: {
      value: (_vm.inteForm.definePrizeUrl),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "definePrizeUrl", $$v)
      },
      expression: "inteForm.definePrizeUrl"
    }
  }, [_vm._v("自定义URL")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.inteForm.definePrizeUrl == "true") ? _c('el-input', {
    staticClass: "inputTitle",
    attrs: {
      "placeholder": "请输入自定义url"
    },
    model: {
      value: (_vm.inteForm.prizeUrl),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "prizeUrl", $$v)
      },
      expression: "inteForm.prizeUrl"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "time",
    attrs: {
      "label": "兑换开始时间：",
      "prop": "startTime"
    }
  }, [_c('el-date-picker', {
    staticClass: "qizhiDate",
    attrs: {
      "format": "yyyy/MM/dd",
      "placeholder": "yyyy/MM/dd"
    },
    model: {
      value: (_vm.inteForm.startTime),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "startTime", $$v)
      },
      expression: "inteForm.startTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "time",
    attrs: {
      "label": "兑换结束时间：",
      "prop": "endTime"
    }
  }, [_c('el-date-picker', {
    staticClass: "qizhiDate",
    attrs: {
      "format": "yyyy/MM/dd",
      "placeholder": "yyyy/MM/dd"
    },
    model: {
      value: (_vm.inteForm.endTime),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "endTime", $$v)
      },
      expression: "inteForm.endTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "prizeContent",
    attrs: {
      "label": "广告曝光代码:"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5
      },
      "placeholder": "广告曝光代码"
    },
    model: {
      value: (_vm.inteForm.adExposingCodes),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "adExposingCodes", $$v)
      },
      expression: "inteForm.adExposingCodes"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "prizeContent",
    attrs: {
      "label": "文案类型：",
      "required": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.inteForm.isRedeem),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "isRedeem", $$v)
      },
      expression: "inteForm.isRedeem"
    }
  }, [_vm._v("兑奖码类型")]), _vm._v(" "), _c('el-radio', {
    staticClass: "inline",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.inteForm.isRedeem),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "isRedeem", $$v)
      },
      expression: "inteForm.isRedeem"
    }
  }, [_vm._v("自定义文案")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "prizeContent",
    attrs: {
      "label": "文案："
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5
      },
      "placeholder": "文案"
    },
    model: {
      value: (_vm.inteForm.defineText),
      callback: function($$v) {
        _vm.$set(_vm.inteForm, "defineText", $$v)
      },
      expression: "inteForm.defineText"
    }
  })], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5715b5d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/integration/newIntegration.vue
// module id = 1032
// module chunks = 0